import { Paper, FormHelperText } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useField } from 'formik';
import React, { useCallback } from 'react';

const useFileFieldStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  label: {
    display: 'block',
  },
  input: {
    display: 'block',
  },
}));

export type FileFieldProps = {
  id?: string;
  name: string;
  label: string;
  accept?: string;
};

export const FileField: React.VFC<FileFieldProps> = ({ id, name, label, accept }) => {
  const { classes } = useFileFieldStyles();
  const [ field, meta ] = useField<File>(name);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    field.onChange({
      target: {
        name: name,
        type: 'file',
        value: e.currentTarget.files?.[0]
      }
    });
  }, [ field, name ]);

  return (
    <Paper variant="outlined" className={classes.root}>
      <label htmlFor={id ?? name}>
        {label}
      </label>
      <input
        className={classes.input}
        type="file"
        id={id || name}
        name={name}
        accept={accept}
        onChange={handleChange}
      />
      {meta.error && (
        <FormHelperText error={!!meta.error}>
          {meta.error}
        </FormHelperText>
      )}
    </Paper>
  );
};
